import { CSSProperties } from 'react'
import { Grid as MuiGrid } from '@mui/material'

interface CardProps {
  children: React.ReactNode
  style?: CSSProperties
  sx?: any
  container?: boolean
  item?: boolean
  xs?: any
  sm?: any
  md?: any
  lg?: any
  xl?: any
  maxWidth?: 'xs' | 'xl' | 'sm' | 'md' | 'lg'
  spacing?: number
}

export const Grid = (props: CardProps) => {
  const {
    children,
    container,
    item,
    style,
    xs,
    sm,
    md,
    lg,
    xl,
    maxWidth,
    spacing
  } = props

  if (container) {
    return (
      <MuiGrid
        maxWidth={maxWidth}
        style={style}
        container={container}
        spacing={spacing}
      >
        {children}
      </MuiGrid>
    )
  }

  return (
    <MuiGrid
      style={style}
      item={item}
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      spacing={spacing}
    >
      {children}
    </MuiGrid>
  )
}

Grid.defaultProps = {
  container: false,
  item: false,
  xs: 100,
  sm: 100,
  md: 100,
  lg: 100,
  xl: 100
  // maxWidth: 'xl'
}
